import { TextStyleKit } from "@tiptap/extension-text-style";
import StarterKit from "@tiptap/starter-kit";

import { FontSize } from "@av/components/organisms/editor/editor-extensions";
import { configuredLinkExtension } from "@av/components/organisms/editor/link-config";

// Render-side extension set used by RenderDocAsHTML. Shares the FontSize
// extension with the writer's set (richTextEditorExtensions in
// @av/components/organisms/editor/editor-extensions.ts) so class-based
// font-size rendering stays consistent before DOMPurify sees the output.
// Note: this set intentionally diverges elsewhere (leaves horizontalRule
// enabled, and omits autolink).
export const extensions = [
  TextStyleKit.configure({
    backgroundColor: false,
    fontFamily: false,
    fontSize: false,
    lineHeight: false,
  }),
  FontSize,
  StarterKit.configure({
    link: false,
  }),
  configuredLinkExtension(),
];
